import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import "./SceneTypeSelector.scss";
import Product from "@ltypes/product";
import { sceneTypes } from "../../../constants";

type SceneTypeSelectorProps = {
    className?: string,
    label: string,
    value: number,
    product: Product,
    onChange?: (id: number) => void,
};

function SceneTypeSelector(props: SceneTypeSelectorProps) {
    const [value, setValue] = useState<number>(props.value);

    const { t } = useTranslation();

    const allowedScenes: Array<number> = useMemo(() => {
        return [0, 11, 1, 2, 3, 4, 8, 12, 10, /*9,*/ 7].filter((sceneId: number) => {
            if(sceneId == 11 && props.product.version.value < 2026.2) {
                return false;
            }

            if(sceneId == 12 && props.product.version.value < 2026.2) {
                return false;
            }

            if(sceneId == 10 && props.product.version.value < 2026.2) {
                return false;
            }

            return true;
        });
    }, [props.product]);

    const handleClick = (itemId: number) => {
        if(props.onChange)
            props.onChange(itemId);
        setValue(itemId);
    };

    useEffect(() => {
        setValue(props.value);
    }, [props.value]);

    return (
        <div className="input-scenetype-selector">
            <span className="textfield-label">{props.label}</span>
            <div className={`input-scenetype-selector-list ${props.className ?? ''}`}>
                {allowedScenes.map((sceneType: number) => (
                    <div key={sceneType} onClick={() => handleClick(sceneType)} className={`input-scenetype-selector-item ${value == sceneType ? 'active' : ''}`}>
                        <div className={`input-scenetype-selector-item-image img-scenetype-${sceneTypes[sceneType]}`}>
                            {sceneType == 4 && (
                                <video autoPlay muted loop playsInline preload="auto" width="100%" height="100%">
                                    <source src="/videos/gif.mp4" type="video/mp4"/>
                                    Votre navigateur ne supporte pas la vidéo HTML5.
                                </video>
                            )}
                        </div>
                        <div className="input-scenetype-selector-item-label">{t(`page.scenes.type.${sceneTypes[sceneType]}`)}</div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default SceneTypeSelector;
